exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option[data-v-28e0c428]{padding:.35rem 1.5rem .35rem 2.3rem}.option.active[data-v-28e0c428],.option[data-v-28e0c428]:hover{background-color:#f8f9fa}.option label[data-v-28e0c428]{font-weight:400}.option.disabled label[data-v-28e0c428]{color:#adb5bd}.option.disabled[data-v-28e0c428]:hover{background-color:transparent}", ""]);

// exports
